export class CertificateMessages {
  public action = 'certificate.action';
  public after = 'certificate.after';
  public before = 'certificate.before';
  public choose = 'certificate.choose';
  public name = 'certificate.name';
  public certificateList = 'certificate.certificate-list';
  constructor() {
  }
}
